import { render, staticRenderFns } from "./TemporarySaveUserFixedPhraseSelector.vue?vue&type=template&id=cbae540a&scoped=true&"
import script from "./TemporarySaveUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./TemporarySaveUserFixedPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TemporarySaveUserFixedPhraseSelector.vue?vue&type=style&index=0&id=cbae540a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae540a",
  null
  
)

export default component.exports